import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';

@Component({
  selector: 'cjp-date-field',
  templateUrl: './date-field.component.html',
  styleUrls: ['./date-field.component.scss'],
})
export class DateFieldComponent implements OnInit {
  @Input()
  public title: string;

  @Input()
  public formFieldName: string;

  @Input() parent: FormGroup;

  @Input() helpText: string;

  required: boolean;

  constructor() {}

  ngOnInit() {
    if (this.parent && this.parent.get(this.formFieldName)) {
      const validator = this.parent.get(this.formFieldName).validator;

      if (validator) {
        this.required = validator({} as AbstractControl).required;
      }
    }
  }
}
